import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Switch, Row, Col } from 'antd';
import { SaveOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { jadeTypeApi, uploadApi } from '../../services/api';
import PhotoUpload from '../../components/PhotoUpload';

const { TextArea } = Input;

const JadeTypeForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [photos, setPhotos] = useState([]);
  const navigate = useCompanyNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  useEffect(() => {
    if (isEdit) {
      fetchData();
    }
  }, [id]);

  const handleUploadSuccess = () => {
    fetchData();
  };

  const fetchData = async () => {
    setLoadingData(true);
    try {
      const res = await jadeTypeApi.detail(id);
      const data = res.data;
      setPhotos(data.photos || []);
      form.setFieldsValue({
        name: data.name,
        origin: data.origin,
        origin_environment: data.origin_environment,
        geological_formation: data.geological_formation,
        history: data.history,
        cultural_image: data.cultural_image,
        features: data.features,
        is_active: data.is_active === 1,
      });
    } finally {
      setLoadingData(false);
    }
  };


  const onFinish = async (values) => {
    setLoading(true);
    try {
      const data = {
        ...values,
        is_active: values.is_active ? 1 : 0,
      };

      if (isEdit) {
        await jadeTypeApi.update(id, data);
        message.success('更新成功');
      } else {
        await jadeTypeApi.create(data);
        message.success('创建成功');
        navigate('/admin/jade-types');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24, gap: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/admin/jade-types')}>
          返回
        </Button>
        <h2 style={{ margin: 0 }}>{isEdit ? '编辑料种' : '新增料种'}</h2>
      </div>

      <Card loading={loadingData}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item
                name="name"
                label="料种名称"
                rules={[{ required: true, message: '请输入料种名称' }]}
              >
                <Input placeholder="如: 和田籽料" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="origin"
                label="产地"
              >
                <Input placeholder="如: 新疆和田地区" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="origin_environment"
            label="产地环境"
          >
            <TextArea rows={3} placeholder="描述产地自然环境，如海拔、气候、地形等" />
          </Form.Item>

          <Form.Item
            name="geological_formation"
            label="地质形成"
          >
            <TextArea rows={3} placeholder="描述玉石形成的地质条件" />
          </Form.Item>

          <Form.Item
            name="history"
            label="历史渊源"
          >
            <TextArea rows={3} placeholder="描述该料种的历史文化背景" />
          </Form.Item>

          <Form.Item
            name="cultural_image"
            label="文化意象"
          >
            <TextArea rows={3} placeholder="描述该料种在文化中的象征意义" />
          </Form.Item>

          <Form.Item
            name="features"
            label="特点描述"
          >
            <TextArea rows={3} placeholder="描述该料种的外观特征和品质特点" />
          </Form.Item>

          <Form.Item label="矿区照片">
            {isEdit ? (
              <PhotoUpload
                batchId={id}
                isBatchUpload={true}
                rawMaterialPhotos={photos}
                onUploadSuccess={handleUploadSuccess}
                uploadPhotoApi={(formData) => uploadApi.uploadJadeTypeImage(id, formData)}
                deletePhotoApi={(photoId) => uploadApi.deleteJadeTypePhoto(photoId)}
              />
            ) : (
              <div style={{ color: '#999', padding: '16px', border: '1px dashed #d9d9d9', borderRadius: 8 }}>
                保存料种后可上传矿区照片
              </div>
            )}
          </Form.Item>

          <Form.Item
            name="is_active"
            label="状态"
            valuePropName="checked"
          >
            <Switch checkedChildren="启用" unCheckedChildren="禁用" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              icon={<SaveOutlined />}
              loading={loading}
              size="large"
              style={{ background: '#8B7355' }}
            >
              {isEdit ? '保存修改' : '创建料种'}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default JadeTypeForm;